module.exports = __webpack_public_path__ + "static/media/get-involved-4.e8dded0e.md";